// StartScreen.js

import React, { useState, useEffect } from "react";
import { checkAndInitializeDB } from '../../component/indexedDB/indexedDB'; // Adjust import path as needed
import QuestionPublicLink from "../../component/PublicLink/PublicLink";
import { QuizScreen, QuizTitle, QuizButton, QuizMessage, QuizForm, QuizInput, QuizFormVertical } from "../GeneralStyles";

const StartScreen = ({ content, overViewPage, enableNavigationButton = () => {} }) => {
  const [name, setName] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    let storedName = sessionStorage.getItem('currentSessionName');
    if (storedName) {
      setName(storedName);
      checkAndInitializeDB(storedName);
      enableNavigationButton(); // Enable navigation if a name is already stored
    } else {
      checkAndInitializeDB('Leerling'); // Initialize with default name if none provided
    }
  }, [enableNavigationButton]);

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (name.trim() === "") { 
      setMessage("Vul een geldige naam in.");
      return;
    }
    sessionStorage.setItem('currentSessionName', name);
    checkAndInitializeDB(name);
    setMessage("Welkom " + name + " je kan nu de EDUbox starten");
    setIsDisabled(true); // Optionally disable changing name after set
    // Enable the NavigationButton
    enableNavigationButton();
  };

  return (
    <QuizScreen bgColor={content.theme_color} bgVisible={overViewPage} id="start_screen">
      <QuestionPublicLink overViewPage={overViewPage} type="question" quiz_item_id="startscreen_name" />
      <QuizTitle textAlign="center">{content.start_screen_quiz_title}</QuizTitle>
      <QuizForm onSubmit={handleSubmit}>
        <QuizFormVertical>
          <QuizInput
            onChange={handleNameChange}
            maxLength={content.start_screen_quiz_maximum_characters}
            value={name}
            placeholder="Vul je naam in"
          />
          <QuizButton type="submit" className='buttonSubmit' bgColor={content.theme_color} txtColor="#FFFFFF" disabled={isDisabled}>
            {content.start_screen_quiz_submit_button_text}
          </QuizButton>
          <QuizMessage className="message" dangerouslySetInnerHTML={{ __html: message || '\u00A0' }}></QuizMessage>
        </QuizFormVertical>
      </QuizForm>
    </QuizScreen>
  );
};

export default StartScreen;
